import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { request } from "../../request";
import { MainContext } from "../../MainContext";

const Login = () => {
    const navigate = useNavigate();
    const { darkMode, updateToken } = useContext(MainContext);
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");

    const handleClick = async (e) => {
        e.preventDefault();
        const res = await request
            .post("/user/login", {
                login: username,
                pass: password,
            })
            .catch((error) => {
                Swal.fire({
                    title: "Error!",
                    text: "Wrong password or username",
                    icon: "error",
                    confirmButtonText: "Close",
                });
            });

        const token = res.data;
        localStorage.setItem("token", token);
        localStorage.setItem("login", username);
        updateToken(token);

        if (token) {
            navigate("/wallet");
        }
    };

    useEffect(() => {
        const token = localStorage.getItem("token");
        if (token) {
            navigate("/wallet");
        }
    }, []);

    return (
        <div
            class="relative flex size-full min-h-screen flex-col bg-white group/design-root overflow-x-hidden"
            style={{
                fontFamily: '"Work Sans", "Noto Sans", sans-serif',
                backgroundColor: darkMode ? "black" : "white",
            }}
        >
            <div class="layout-container flex h-full grow flex-col">
                <div className="container mx-auto my-auto p-10 max-w-[900px] bg-white border border-gray-300 rounded-lg shadow-lg" style={{ backgroundColor: darkMode ? "#141619" : "white" }}>
                    <h1 className="text-2xl font-bold mb-4" style={{ color: darkMode ? "white" : "black" }}>
                        Login
                    </h1>
                    <form className="mb-4">
                        <div className="flex flex-col mb-4">
                            <label className="text-lg mb-2" htmlFor="name" style={{ color: darkMode ? "white" : "black" }}>
                                Username
                            </label>
                            <input type="text" id="name" value={username} onChange={(e) => setUsername(e.target.value)} className="border p-2 rounded" placeholder="Enter Username" required />
                        </div>
                        <div className="flex flex-col mb-4">
                            <label className="text-lg mb-2" htmlFor="value" style={{ color: darkMode ? "white" : "black" }}>
                                Password
                            </label>
                            <input type="password" id="contact" value={password} onChange={(e) => setPassword(e.target.value)} className="border p-2 rounded" placeholder="Enter Password" required />
                        </div>
                        <div style={{ display: "flex" }}>
                            <button
                                type="submit"
                                onClick={handleClick}
                                className="flex min-w-[84px] max-w-[480px] mt-4 cursor-pointer items-center justify-center overflow-hidden rounded-xl h-10 px-4 bg-gray-200 text-[#111418] text-sm font-bold leading-normal tracking-[0.015em]"
                                style={{
                                    backgroundColor: darkMode ? "#FEC901" : "#FEC901",
                                }}
                            >
                                Login
                            </button>
                            <button
                                type="submit"
                                onClick={async () => {
                                    const { value: userInput } = await Swal.fire({
                                        title: "Enter your email",
                                        input: "email",
                                        inputLabel: "Email",
                                        inputPlaceholder: "Email here...",
                                        showCancelButton: true,
                                    });

                                    // If user canceled, exit
                                    if (!userInput) return;

                                    try {
                                        await request.post("/user/revoke-password/", { email: userInput });

                                        Swal.fire("Success!", "Your email has been sent.", "success");
                                    } catch (err) {
                                        Swal.fire("Error!", "Failed to send input.", "error");
                                    }
                                }}
                                className="flex min-w-[84px] max-w-[480px] mt-4 cursor-pointer items-center justify-center overflow-hidden rounded-xl h-10 px-4 bg-gray-200 text-[#111418] text-sm font-bold leading-normal tracking-[0.015em]"
                                style={{
                                    backgroundColor: darkMode ? "#333" : "#333",
                                    color: "white",
                                    marginLeft: "15px",
                                }}
                            >
                                Forgot password
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default Login;
